/**
 * SessionModeContext — injected by PatientSession into each game component.
 *
 * When active, games should:
 *   1. Skip the setup screen and start in 'playing' state immediately.
 *   2. Initialise state from `config` instead of their defaults.
 *   3. Call `onComplete(rawData)` instead of sessions.submit() when done.
 */
import { createContext, useContext } from 'react'
import type { PlaybookItemConfig } from './activityConfig'

export interface SessionModeResult {
  durationMs?:   number
  moves?:        number
  pairsTotal?:   number
  pairsMatched?: number
}

export interface SessionModeValue {
  config:     PlaybookItemConfig
  onComplete: (result: SessionModeResult) => void
}

export const SessionModeContext = createContext<SessionModeValue | null>(null)

export function useSessionMode() {
  return useContext(SessionModeContext)
}
